import React from 'react';

const Buoy = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="buoy_icon"
    viewBox="0 0 48 48"
  >
    <g fill="none" fillRule="evenodd" strokeWidth="1.5">
      <path
        stroke="#FFF"
        d="M38.43 6.1A22.893 22.893 0 0 0 23.99 1 22.893 22.893 0 0 0 9.605 6.056m-3.17 3.088A22.898 22.898 0 0 0 1 23.99a22.9 22.9 0 0 0 5.63 15.072m3.42 3.21a22.889 22.889 0 0 0 13.94 4.707 22.89 22.89 0 0 0 14.062-4.801m3.338-3.164A22.9 22.9 0 0 0 46.98 23.99c0-5.401-1.862-10.367-4.98-14.29M13.524 15.998a13.059 13.059 0 0 0-2.687 7.955 13.06 13.06 0 0 0 2.849 8.162m3.303 2.954c2.018 1.268 4.405 2 6.964 2 2.55 0 4.929-.727 6.942-1.985m3.412-3.078a13.06 13.06 0 0 0 2.762-8.053c0-2.805-.88-5.405-2.38-7.537m-3.555-3.44a13.055 13.055 0 0 0-7.18-2.139c-2.682 0-5.176.805-7.253 2.186"
      />
      <path
        stroke="#27AAE1"
        d="M40.322 5.209a.412.412 0 0 0-.504 0l-9.812 8.678c-.075.067-.075.134.001.202l3.07 2.715c.13.115.375.115.504 0l9.812-8.678c.076-.067.076-.134 0-.201l-3.07-2.716zM39.162 42.867l-9.157-8.679c-.074-.07-.074-.166 0-.236l2.866-2.716a.279.279 0 0 1 .366 0l9.158 8.679c.073.07.073.166-.001.236l-2.865 2.715a.279.279 0 0 1-.367.001zM8.878 5.191a.279.279 0 0 0-.366 0L5.647 7.908c-.074.07-.074.167 0 .236l9.157 8.68c.096.09.27.09.366-.001l2.865-2.716c.075-.07.075-.166.001-.236L8.878 5.19zM8.878 42.867a.279.279 0 0 1-.366 0L5.647 40.15c-.074-.07-.074-.167 0-.236l9.157-8.68a.279.279 0 0 1 .366.001l2.865 2.716c.075.07.075.166.001.236l-9.158 8.679z"
      />
    </g>
  </svg>
);

export default Buoy;
